import constants from '../../../../../../appConstants';
import { formatDateTime } from '@dataGrid/gridUtilities';
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { CustomerNameCellRenderer } from '../../../../../common/CustomerMergeIndicator/CustomerNameCell';
class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ name }) {
    return GridConfig.getDefaultConfiguration({ name });
  }

  static getCustomerAddress(params) {
    return [params.data.address, params.data.address2].filter(Boolean).join(', ');
  }



  static getDefaultConfiguration({ name }) {
    return {
      title: name,
      keyColumn: 'code',
      rowSelection: 'multiple',
      rowDeselection: 'true',
      columns: [
        {
          headerName: 'Acc #',
          headerTooltip: 'Customer Account Number',
          field: 'displayCustomerCode',
          minWidth: constants.columnWidth.CUSTOMER_CODE,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'displayCustomerCode',
          lockPosition: true
        },
        {
          headerName: 'Customer Name',
          headerTooltip: 'Customer Name',
          field: 'displayCustomerName',
          minWidth: constants.columnWidth.CUSTOMER,
          lockPosition: true,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          cellRenderer: CustomerNameCellRenderer,
          filterParams: {
            width: constants.columnWidth.W_300
          }
        },
        {
          headerName: 'Address',
          headerTooltip: 'Customer Address',
          minWidth: constants.columnWidth.CUSTOMER_ADDRESS,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: GridConfig.getCustomerAddress,
          tooltipValueGetter: (params) => params.value,
          filterParams: {
            width: constants.columnWidth.W_300
          }
        },
        {
          headerName: 'City',
          headerTooltip: 'City',
          field: 'city',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.CITY,
          filter: MultiSelectFilter,
          tooltipField: 'city'
        },
        {
          headerName: 'State',
          headerTooltip: 'State',
          field: 'state',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.STATE,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Zip',
          headerTooltip: 'Zip',
          field: 'zip',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.ZIP_CODE,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Terminal',
          headerTooltip: 'Terminal',
          field: 'terminalCode',
          cellClass: 'gridCell-leftAlign',
          minWidth: constants.columnWidth.W_100,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Last Updated (UTC)',
          headerTooltip: 'Last Updated (UTC)',
          field: 'lastUpdated',
          minWidth: constants.columnWidth.IBETA,
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
          valueFormatter: formatDateTime,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME
          }
        }
      ]
    };
  }
}

export default GridConfig;
